import React, { useState } from 'react';
import { BalanceCardsSection } from '../../components/domain-sections/BalanceCardsSection';
import type { BalanceCardItem } from '../../components/domain-sections/BalanceCardsSection';
import { TERMINAL_BALANCE_DATA } from '@shared/data/mockTerminalsPanels';

export const BalanceSection = React.memo(() => {
  const [balances, setBalances] = useState<BalanceCardItem[]>(TERMINAL_BALANCE_DATA);

  const handleBalanceAction = (_action: string, _balanceId: string) => {
    // Handle terminal balance actions (withdraw, transfer, etc.)
  };

  const handleAddBalance = () => {
    const newBalance: BalanceCardItem = {
      id: `terminal_balance_${Date.now()}`,
      label: 'New Terminal Account',
      totalBalance: '$0.00',
      balances: [
        { currency: 'USD', amount: 0, formatted: '$0.00' },
        { currency: 'EUR', amount: 0, formatted: '€0.00' }
      ],
      status: 'new_terminal_balance',
      bgColor: 'bg-indigo-50',
      textColor: 'text-indigo-900'
    };
    
    setBalances(prev => [...prev, newBalance]);
  };

  return (
    <BalanceCardsSection
      balances={balances}
      onBalanceAction={handleBalanceAction}
      onAddBalance={handleAddBalance}
      showAddCard={true}
      addCardTitle="Add terminal account"
      addCardDescription="Create a new balance account for terminal operations"
    />
  );
});

BalanceSection.displayName = 'BalanceSection';